import { supabase } from '../lib/supabase';
import { retryWithBackoff } from '../utils/retryWithBackoff';

export const createJob = async (jobData) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('jobs')?.insert([jobData])?.select()?.single();

    if (error) throw error;
    return data;
  });
};

export const getJobs = async (filters = {}) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    let query = supabase?.from('jobs')?.select('*');

    if (filters?.status) {
      query = query?.eq('status', filters?.status);
    }
    if (filters?.category) {
      query = query?.eq('category', filters?.category);
    }
    if (filters?.client_id) {
      query = query?.eq('client_id', filters?.client_id);
    }

    const { data, error } = await query?.order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  });
};

export const getJobById = async (jobId) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('jobs')?.select('*')?.eq('id', jobId)?.single();

    if (error) throw error;
    return data;
  });
};

export const updateJob = async (jobId, updates) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('jobs')?.update(updates)?.eq('id', jobId)?.select()?.single();

    if (error) throw error;
    return data;
  });
};

export const deleteJob = async (jobId) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { error } = await supabase?.from('jobs')?.delete()?.eq('id', jobId);

    if (error) throw error;
  });
};

export const applyToJob = async (applicationData) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('job_applications')?.insert([applicationData])?.select()?.single();

    if (error) throw error;
    return data;
  });
};

export const getJobApplications = async (jobId) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('job_applications')?.select('*')?.eq('job_id', jobId)?.order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  });
};

export const updateApplicationStatus = async (applicationId, status) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('job_applications')?.update({ status })?.eq('id', applicationId)?.select()?.single();

    if (error) throw error;
    return data;
  });
};

export const jobService = (...args) => {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: jobService is not implemented yet.', args);
  return null;
};

export default jobService;